import {
  arrayOf, bool, func, shape, string,
} from 'prop-types';
import React, { PureComponent } from 'react';
import { View } from 'react-native';
import { InputLabel } from 'reactor/components/Input';
import { LAYOUT } from 'reactor/common';

import { sortBy } from './modules';
import DataRow from './DataRow';
import styles from './DataTable.style';

const { VIEWPORT: { LANDSCAPE } } = LAYOUT;


class DataTable extends PureComponent {
  static propTypes = {
    border: bool,
    caption: string,
    onChange: func,
    onItem: func,
    parse: func,
    schema: shape({}),
    shadow: bool,
    values: arrayOf(shape({})),
  };

  static defaultProps = {
    border: false,
    caption: undefined,
    onChange: undefined,
    onItem: undefined,
    parse: value => value,
    schema: {},
    shadow: false,
    values: [],
  };

  constructor(props) {
    super(props);

    const { values } = props;
    this.state = { sort: undefined, values };
  }

  componentWillReceiveProps({ values }) {
    this.setState({ sort: undefined, values });
  }

  _onChange = (index, value) => {
    const { props: { onChange } } = this;
    let { state: { values } } = this;

    values = values.map((stored, i) => (i === index ? value : stored));
    this.setState({ values });
    if (onChange) onChange(values);
  }

  _onSort = (field) => {
    const { props: { schema }, state: { sort = {}, values } } = this;
    const asc = field !== sort.field ? true : !sort.asc;
    const isIcon = schema[field].type === 'icon';

    if (!isIcon) {
      this.setState({
        sort: { field, asc },
        values: sortBy(field, schema, values, asc),
      });
    }
  }

  render() {
    const {
      _onChange, _onSort,
      props: {
        border, caption, onChange, onItem, parse, schema, shadow, ...inherit
      },
      state: { sort, values = [] },
    } = this;

    return (
      <View style={[styles.container, !LANDSCAPE && styles.containerMobile]}>
        { caption && <InputLabel>{caption}</InputLabel> }
        <View style={[
          styles.content,
          !LANDSCAPE && styles.contentMobile,
          border && styles.border,
          shadow && styles.shadow,
          inherit.style]}
        >
          <DataRow
            heading
            onPress={values.length > 0 ? _onSort : undefined}
            sort={sort}
            schema={schema}
          />
          { values.map((value, index) => (
            <DataRow
              even={index % 2 === 0}
              key={index.toString()}
              schema={schema}
              value={parse(value)}
              onChange={onChange ? rowValue => _onChange(index, rowValue) : undefined}
              onPress={onItem}
              ref={value.reference ? value.reference : undefined}
            />
          ))}
        </View>
      </View>
    );
  }
}

export default DataTable;
